import { RiskItem } from "components/summary/success-plan/context/SuccessPlanContext";
import styles from "../SuccessPlan.module.scss";

type RiskLabelProps = {
  prefix?: string;
  riskItem: RiskItem | undefined;
};

const RiskLabel = ({ prefix, riskItem }: RiskLabelProps) => {
  return (
    <span
      className={styles["sp-label"]}
      style={{
        display: "inline-flex",
        alignSelf: "flex-start",
        color: riskItem?.color,
        backgroundColor: riskItem?.backgroundColor || "#e1e1e1",
        padding: "8px 16px",
        borderRadius: "4px",
      }}
    >
      {prefix && `${prefix}: `}
      {riskItem?.value || "N/A"}
    </span>
  );
};

export default RiskLabel;
